import React from 'react';

import "./index.scss";

export default function Policies(props) {
    if (props.element.length <= 0) {
        return 'No policies defined';
    }

    function createMarkup(text) {
        return { __html: text };
    }

    return (
        <React.Fragment>
            {
                props.element.map((policy, index) => {
                    let policyText = null;
                    if(policy.Policy) policyText = policy.Policy;
                    if(policy.PolicyText) policyText = policy.PolicyText;
                    return (
                        <React.Fragment key={index}>
                            <div className="policyName">{policy.PolicyName}</div>
                            <div className="description" dangerouslySetInnerHTML={createMarkup(policyText)} />
                        </React.Fragment>
                    );
                })
            }
        </React.Fragment>
    )
}